import { Container } from 'inversify-props';
import setupProductInformation from './product-information/setup';

export default function setupInvestmentProduct(container: Container) {
  setupProductInformation(container);
}
